import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Influencer } from '@cuepid/core';

export interface ReconnectAlertDialogData {
  influencer: Influencer;
}

@Component({
  selector: 'app-reconnect-alert-dialog',
  templateUrl: './reconnect-alert-dialog.component.html',
  styleUrls: ['./reconnect-alert-dialog.component.scss'],
})
export class ReconnectAlertDialogComponent {
  disconnectedAccounts: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ReconnectAlertDialogData,
    private readonly ref: MatDialogRef<ReconnectAlertDialogComponent>
  ) {
    if (data.influencer.instagram_account?.need_reconnect) {
      this.disconnectedAccounts.push('Instagram');
    }
    if (data.influencer.tiktok_account?.need_reconnect) {
      this.disconnectedAccounts.push('TikTok');
    }
  }

  get accountNames(): string {
    return this.disconnectedAccounts.join('・');
  }

  close() {
    this.ref.close(false);
  }

  goToReconnect() {
    this.ref.close(true);
  }
}
